import { focusAtom } from "jotai-optics";
import { atomFamily } from "jotai/utils";
import { modelAtom } from "./model";
import { Cell, CellTypes, TextCell } from "./types";

const cache = atomFamily(
  ({ cell, id }: { id: string; cell: Cell | TextCell }) =>
    focusAtom(modelAtom, (optic) =>
      optic
        .prop("cells")
        .prop(id)
        .valueOr(cell as CellTypes)
        // this fixes an error where types is stored in the cell json
        // @ts-expect-error: reread is not typed in jotai-optics but is required for cell type update
        .reread((v) => ({ ...v, type: cell.type || "dollar" })),
    ),
  (a, b) => a.id === b.id,
);

export const createStorableCellAtom = (id: string, cell: CellTypes) => {
  return cache({ id, cell });
};
